/**
 * Vue3 埋点指令
 * 使用方式:
 * v-track:click="{ name: 'button_name', data: {...} }"
 * v-track:view="{ page: 'page_name' }"
 */

import analytics from '../utils/analytics'

export default {
  install(app) {
    // 点击埋点指令
    app.directive('track', {
      mounted(el, binding) {
        const { arg, value } = binding
        
        if (arg === 'click') {
          // 按钮点击埋点
          el.addEventListener('click', () => {
            const eventName = value.name || el.textContent || 'unknown_button'
            const eventData = value.data || {}
            
            analytics.buttonClick(eventName, {
              button_location: value.location || 'unknown',
              button_id: el.id || null,
              button_text: el.textContent || null,
              ...eventData
            })
          })
        } else if (arg === 'view') {
          // 页面访问埋点
          const pageUrl = value.page || window.location.pathname
          const options = value.options || {}
          
          analytics.pageView(pageUrl, options)
        }
      }
    })
    
    // 页面访问埋点指令（简化版）
    app.directive('page-view', {
      mounted(el, binding) {
        const pageUrl = binding.value || window.location.pathname
        analytics.pageView(pageUrl)
      }
    })
    
    // 按钮点击埋点指令（简化版）
    app.directive('track-click', {
      mounted(el, binding) {
        el.addEventListener('click', () => {
          const { name, location, data } = binding.value || {}
          const eventName = name || el.textContent || 'unknown_button'
          
          analytics.buttonClick(eventName, {
            button_location: location || 'unknown',
            button_id: el.id || null,
            button_text: el.textContent || null,
            ...data
          })
        })
      }
    })
  }
}

